import { KomaIDModel } from '../vo/koma-id.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 組合員の声削除コマンド
 *
 * @export
 * @class DeletePublishVoiceService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class DeletePublishVoiceService extends PlessJsonResponderSub<any> {

  /** 処理に使用するModel */
  private vo: KomaIDModel = null;
  private successFunc: Function = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof DeletePublishVoiceService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        KomaId: this.vo.komaID,
        OrderGoodsFlg: this.vo.orderGoodsFlg
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KomaIDModel} vo パラメータ
   * @memberof DeletePublishVoiceService
   */
  execute(vo: KomaIDModel, successFunc: Function) {
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW14deletePublishVoice', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} _ レスポンスデータ
   * @memberof DeletePublishVoiceService
   */
  success(_: any) {
    this.successFunc();
  }
}
